export default __webpack_public_path__ + "4315d7485b92fed35b7504c54a47ff6a.png";